(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-about-founders"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');

    function initHdAbdocsReveal(root) {
      var els = root.querySelectorAll('.hd-abdocs [data-hd-rv]');
      if (!els.length) return;

      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) {
          el.classList.add('is-in');
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      els.forEach(function (el) {
        io.observe(el);
      });
    }

    initHdAbdocsReveal(document);

    // Shopify's theme editor replaces this section's HTML via AJAX when a
    // merchant edits a setting (e.g. swapping a doctor photo) - no full page
    // reload happens, so fresh [data-hd-rv] elements start at their default
    // opacity: 0 with no observer watching them, making the whole section's
    // content appear to vanish until a real page reload. Re-running the
    // observer setup on shopify:section:load (scoped to the just-reloaded
    // section root) fixes this for the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      initHdAbdocsReveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.documentElement.classList.add('js');

    function initHdAboutHeroReveal(root) {
      var els = root.querySelectorAll('.hd-about-hero [data-hd-rv]');
      if (!els.length) return;

      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) {
          el.classList.add('is-in');
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      els.forEach(function (el) {
        io.observe(el);
      });
    }

    initHdAboutHeroReveal(document);

    // Shopify's theme editor replaces this section's HTML via AJAX when a
    // merchant edits a setting (no full page reload), leaving fresh
    // [data-hd-rv] elements at their default opacity: 0 with no observer
    // watching them - the reveal never fires again until a real reload.
    // Re-running the observer setup on shopify:section:load (scoped to the
    // just-reloaded section root) fixes this for the theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      initHdAboutHeroReveal(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-numbers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stats = document.querySelectorAll('[data-hd-abnum-stat]');
    if (!stats.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function format(n) {
      return n.toLocaleString('en-AU');
    }

    function run(stat) {
      stat.classList.add('is-in');
      var target = parseInt(stat.getAttribute('data-target'), 10) || 0;
      var valEl = stat.querySelector('[data-hd-abnum-val]');
      if (!valEl) return;

      if (reduceMotion) {
        valEl.textContent = format(target);
        return;
      }

      if (stat._hdRaf) {
        cancelAnimationFrame(stat._hdRaf);
        stat._hdRaf = null;
      }

      var start = null;
      var duration = 2200;

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min(1, (timestamp - start) / duration);
        valEl.textContent = format(Math.round(target * (1 - Math.pow(1 - progress, 3))));
        if (progress < 1) {
          stat._hdRaf = requestAnimationFrame(step);
        } else {
          stat._hdRaf = null;
        }
      }

      stat._hdRaf = requestAnimationFrame(step);
    }

    function stop(stat) {
      stat.classList.remove('is-in');
      if (stat._hdRaf) {
        cancelAnimationFrame(stat._hdRaf);
        stat._hdRaf = null;
      }
      var valEl = stat.querySelector('[data-hd-abnum-val]');
      if (valEl && !reduceMotion) valEl.textContent = '0';
    }

    if (!('IntersectionObserver' in window)) {
      stats.forEach(run);
      return;
    }

    var statIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            run(entry.target);
          } else {
            stop(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    stats.forEach(function (stat) {
      statIo.observe(stat);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-standard"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lists = document.querySelectorAll('[data-hd-abstd]');
    if (!lists.length) return;

    lists.forEach(function (list) {
      var rows = [].slice.call(list.querySelectorAll('[data-hd-abstd-row]'));
      if (!rows.length) return;

      function setRowOpen(row, on) {
        row.classList.toggle('is-open', on);
        row.querySelector('.hd-abstd__btn').setAttribute('aria-expanded', on ? 'true' : 'false');
      }

      rows.forEach(function (r) {
        r.querySelector('.hd-abstd__btn').addEventListener('click', function () {
          setRowOpen(r, !r.classList.contains('is-open'));
        });
      });

      if ('IntersectionObserver' in window) {
        var opened = false;
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !opened) {
                opened = true;
                setRowOpen(rows[0], true);
                io.disconnect();
              }
            });
          },
          { threshold: 0.35 }
        );
        io.observe(list);
      } else {
        setRowOpen(rows[0], true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-about-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var stats = document.querySelectorAll('[data-hd-abstory-stat]');
    if (!stats.length) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function format(n) {
      return n.toLocaleString('en-AU');
    }

    function run(stat) {
      var target = parseInt(stat.getAttribute('data-target'), 10) || 0;
      var valEl = stat.querySelector('[data-hd-abstory-val]');
      if (!valEl) return;
      if (reduceMotion) {
        valEl.textContent = format(target);
        return;
      }
      var start = null;
      var duration = 2000;
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min(1, (timestamp - start) / duration);
        valEl.textContent = format(Math.round(target * (1 - Math.pow(1 - progress, 3))));
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      stats.forEach(run);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          run(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    stats.forEach(function (stat) { io.observe(stat); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(bar) {
      var msgs = bar.querySelectorAll('.hd-ann__msg');
      if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-on');
      }, 4200);
    }
    document.querySelectorAll('[data-hd-rotate]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bundles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-cs-spotlight]').forEach(function (card) {
      var panel = card.querySelector('.hd-csf__body');
      if (!panel) return;

      card.addEventListener('pointermove', function (e) {
        var r = panel.getBoundingClientRect();
        panel.style.setProperty('--hd-mx', ((e.clientX - r.left) / r.width) * 100 + '%');
        panel.style.setProperty('--hd-my', ((e.clientY - r.top) / r.height) * 100 + '%');
      });

      card.addEventListener('pointerleave', function () {
        panel.style.removeProperty('--hd-mx');
        panel.style.removeProperty('--hd-my');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-clinical-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tls = document.querySelectorAll('[data-hd-tl]');
    if (tls.length) {
      if ('IntersectionObserver' in window) {
        var tlIo = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              entry.target.classList.toggle('is-in', entry.isIntersecting);
            });
          },
          { threshold: 0.35 }
        );
        tls.forEach(function (el) {
          tlIo.observe(el);
        });
      } else {
        tls.forEach(function (el) {
          el.classList.add('is-in');
        });
      }
    }

    var stats = document.querySelectorAll('[data-hd-clin-stat]');
    if (!stats.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function run(stat) {
      var target = parseInt(stat.getAttribute('data-target'), 10) || 0;
      var valEl = stat.querySelector('[data-hd-clin-val]');
      if (!valEl) return;

      if (reduceMotion) {
        valEl.textContent = target;
        return;
      }

      if (stat._hdRaf) {
        cancelAnimationFrame(stat._hdRaf);
        stat._hdRaf = null;
      }

      var start = null;
      var duration = 4000;

      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min(1, (timestamp - start) / duration);
        valEl.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) {
          stat._hdRaf = requestAnimationFrame(step);
        } else {
          stat._hdRaf = null;
        }
      }

      stat._hdRaf = requestAnimationFrame(step);
    }

    function stop(stat) {
      if (stat._hdRaf) {
        cancelAnimationFrame(stat._hdRaf);
        stat._hdRaf = null;
      }
      var valEl = stat.querySelector('[data-hd-clin-val]');
      if (valEl && !reduceMotion) valEl.textContent = '0';
    }

    if (!('IntersectionObserver' in window)) {
      stats.forEach(run);
      return;
    }

    var statIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            run(entry.target);
          } else {
            stop(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    stats.forEach(function (stat) {
      statIo.observe(stat);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-hd-cmp]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    sections.forEach(function (el) {
      io.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-contact-hero-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hd-contact-faq-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-hd-contact-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-hero-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var searchInput = document.querySelector('[data-faq-search]');
    if (!searchInput) return;

    var categories = Array.prototype.slice.call(document.querySelectorAll('[data-faq-category]'));
    var navLinks = Array.prototype.slice.call(document.querySelectorAll('[data-faq-nav-link]'));
    var emptyState = document.querySelector('[data-faq-empty]');
    var emptyQueryEl = document.querySelector('[data-faq-empty-query]');

    function applyFilter() {
      var query = searchInput.value.trim().toLowerCase();
      var totalVisible = 0;

      categories.forEach(function (categoryEl) {
        var catId = categoryEl.getAttribute('data-faq-category');
        var items = Array.prototype.slice.call(categoryEl.querySelectorAll('[data-faq-item]'));
        var visibleCount = 0;

        items.forEach(function (item) {
          var haystack = item.getAttribute('data-faq-text') || '';
          var match = query === '' || haystack.indexOf(query) !== -1;
          item.hidden = !match;
          if (match) visibleCount += 1;
        });

        categoryEl.hidden = visibleCount === 0;
        totalVisible += visibleCount;

        var navLink = navLinks.filter(function (link) {
          return link.getAttribute('data-faq-nav-link') === catId;
        })[0];

        if (navLink) {
          navLink.hidden = visibleCount === 0;
          var countEl = navLink.querySelector('[data-faq-nav-count]');
          if (countEl) countEl.textContent = '(' + visibleCount + ')';
        }
      });

      if (emptyState) {
        var showEmpty = query !== '' && totalVisible === 0;
        emptyState.hidden = !showEmpty;
        if (showEmpty && emptyQueryEl) emptyQueryEl.textContent = searchInput.value.trim();
      }
    }

    searchInput.addEventListener('input', applyFilter);
  })();

  (function () {
    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-hd-header]');
    if (!header) return;

    var logoBox = header.querySelector('.hd-nav__logo');
    var logoFull = logoBox ? logoBox.querySelector('.hd-nav__logo-full') : null;
    var logoFullWidth = 0;
    var logoIconWidth = 40;

    function measureLogoFull() {
      if (logoFull) logoFullWidth = logoFull.getBoundingClientRect().width;
    }
    measureLogoFull();
    if (logoFull && logoFull.tagName === 'IMG' && !logoFull.complete) {
      logoFull.addEventListener('load', measureLogoFull);
    }
    window.addEventListener('resize', measureLogoFull);

    var scrollTicking = false;
    function updateScrolled() {
      var scrolled = window.scrollY > 20;
      header.classList.toggle('is-scrolled', scrolled);
      if (logoBox) {
        logoBox.style.width = (scrolled ? logoIconWidth : logoFullWidth) + 'px';
      }
      scrollTicking = false;
    }
    window.addEventListener('scroll', function () {
      if (!scrollTicking) {
        window.requestAnimationFrame(updateScrolled);
        scrollTicking = true;
      }
    }, { passive: true });
    updateScrolled();

    var burger = header.querySelector('[data-hd-burger]');
    if (!burger) return;

    var navHtml = Array.prototype.slice.call(header.querySelectorAll('.hd-nav__links a')).map(function (a) {
      return a.outerHTML;
    }).join('');

    var scrim = document.createElement('div');
    scrim.className = 'hd-mm-scrim';
    var mm = document.createElement('div');
    mm.className = 'hd-mm';
    mm.setAttribute('role', 'dialog');
    mm.setAttribute('aria-label', 'Menu');

    mm.innerHTML =
      '<div class="hd-mm__top">' +
      '<button type="button" class="hd-mm__close" aria-label="Close menu"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '</div>' +
      '<nav>' + navHtml + '</nav>';

    document.body.appendChild(scrim);
    document.body.appendChild(mm);

    function open() {
      scrim.classList.add('is-open');
      mm.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    }

    function close() {
      scrim.classList.remove('is-open');
      mm.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
    }

    burger.addEventListener('click', open);
    scrim.addEventListener('click', close);
    mm.querySelector('.hd-mm__close').addEventListener('click', close);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ingredients-formula"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fx]').forEach(function (fx) {
      var num = fx.querySelector('[data-fx-num]');
      var prog = fx.querySelector('[data-fx-prog]');
      var vs = fx.querySelector('.hd-fx__vs');
      var vsNum = fx.querySelector('[data-fx-vs]');
      var vsProg = fx.querySelector('[data-fx-vs-prog]');
      var lists = [].slice.call(fx.querySelectorAll('.hd-fx__list'));
      var seq = [];
      var fills = [];
      var hls = [];

      lists.forEach(function (list) {
        var fillEl = list.querySelector('[data-fx-fill]');
        fills.push(fillEl);
        var hlEl = document.createElement('span');
        hlEl.className = 'hd-fx__hl';
        list.insertBefore(hlEl, list.firstChild);
        hls.push(hlEl);
        var rows = [].slice.call(list.querySelectorAll('.hd-fx__row'));
        rows.forEach(function (row, idx) {
          seq.push({ row: row, fill: fillEl, hl: hlEl, pos: idx, len: rows.length });
        });
      });

      var N = seq.length;
      var timer = null;

      function pad(n) {
        return (n < 10 ? '0' : '') + n;
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var CAP = parseInt(fx.getAttribute('data-fx-cap'), 10) || 5;
      var SPEED = parseInt(fx.getAttribute('data-fx-speed'), 10) || 196;

      function setVs(n) {
        var v = Math.min(CAP, n);
        if (vsNum) vsNum.textContent = pad(v);
        if (vsProg) vsProg.style.width = (v / N * 100) + '%';
        if (vs) vs.classList.toggle('is-capped', n >= CAP);
      }

      function reset() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        seq.forEach(function (s) {
          s.row.classList.remove('is-active', 'is-done');
        });
        fills.forEach(function (f) {
          f.style.transition = 'none';
          f.style.height = '0%';
        });
        hls.forEach(function (h) {
          h.style.transition = 'none';
          h.style.opacity = '0';
          h.style.height = '0px';
        });
        if (num) num.textContent = '01';
        if (prog) prog.style.width = '0%';
        setVs(1);
        if (vs) vs.classList.remove('is-capped');
        fx.classList.remove('is-fin');
      }

      function run() {
        if (reduce) {
          seq.forEach(function (s) {
            s.row.classList.add('is-done');
          });
          fills.forEach(function (f) {
            f.style.height = '100%';
          });
          if (num) num.textContent = pad(N);
          if (prog) prog.style.width = '100%';
          setVs(N);
          fx.classList.add('is-fin');
          return;
        }

        var i = 0;

        (function step() {
          if (i > 0) {
            seq[i - 1].row.classList.remove('is-active');
            seq[i - 1].row.classList.add('is-done');
          }
          if (i >= N) {
            hls.forEach(function (h) {
              h.style.transition = 'opacity .45s';
              h.style.opacity = '0';
            });
            timer = null;
            fx.classList.add('is-fin');
            return;
          }
          var s = seq[i];
          s.row.classList.add('is-active');
          if (s.hl) {
            var hT = s.row.offsetTop + 'px';
            var hH = s.row.offsetHeight + 'px';
            if (s.pos === 0) {
              s.hl.style.transition = 'none';
              s.hl.style.top = hT;
              s.hl.style.height = hH;
              s.hl.style.opacity = '1';
              void s.hl.offsetHeight;
            } else {
              s.hl.style.transition = 'top ' + SPEED + 'ms linear, height ' + SPEED + 'ms linear';
              s.hl.style.top = hT;
              s.hl.style.height = hH;
            }
          }
          if (num) num.textContent = pad(i + 1);
          if (s.pos === 0) {
            void s.fill.offsetHeight;
            s.fill.style.transition = 'height ' + (s.len * SPEED) + 'ms linear';
            s.fill.style.height = '100%';
          }
          if (prog) prog.style.width = ((i + 1) / N * 100) + '%';
          setVs(i + 1);
          i++;
          timer = setTimeout(step, SPEED);
        })();
      }

      if (!('IntersectionObserver' in window)) {
        run();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reset();
            run();
          } else {
            reset();
          }
        });
      }, { threshold: 0.2 });

      io.observe(fx);
    });

    document.querySelectorAll('[data-formula]').forEach(function (root) {
      var tabs = [].slice.call(root.querySelectorAll('.hd-ftab'));
      var panels = [].slice.call(root.querySelectorAll('.hd-fpanel'));

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-panel');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-on');
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          var panel = document.getElementById(idx);
          if (panel) panel.classList.add('is-on');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-product-duo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAccordion(root) {
      root.querySelectorAll('[data-hd-acc-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var row = trigger.closest('.hd-acc__row');
          var panel = row.querySelector('[data-hd-acc-panel]');
          var isOpen = row.classList.contains('is-open');

          if (isOpen) {
            panel.style.height = panel.scrollHeight + 'px';
            requestAnimationFrame(function () {
              panel.style.height = '0px';
            });
            row.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            row.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            panel.style.height = panel.scrollHeight + 'px';
            panel.addEventListener('transitionend', function handler() {
              panel.style.height = 'auto';
              panel.removeEventListener('transitionend', handler);
            });
          }
        });
      });
    }

    function initPurchaseOptions(root) {
      var optionsWrap = root.querySelector('[data-options]');
      if (!optionsWrap) return;

      var sellingPlanInput = root.querySelector('[data-selling-plan-input]');
      // Scoped to .hd-duo__form specifically (2026-10-29, added for the
      // 3-plan toggle's 30-day option, which submits a different
      // product's variant id): root also contains a second, unrelated
      // .product-variant-id hidden input inside the cross-sell card's
      // own mini add-to-cart form - a bare root-wide query would risk
      // grabbing whichever renders first in the DOM instead of the main
      // buy box's, which happens to work today only because the main
      // form renders first.
      var variantIdInput = root.querySelector('.hd-duo__form .product-variant-id');
      var atcPriceEl = root.querySelector('[data-atcprice]');
      var priceValueEl = root.querySelector('[data-price-value]');
      var priceNoteEl = root.querySelector('[data-price-note]');
      // Subscriptions always ship qty 1 (user-requested, 2026-11-01) - the
      // stepper is hidden rather than disabled so the ATC button naturally
      // expands to fill the row (it's already flex:1 1 auto next to the
      // stepper in .hd-duo__buybox, nothing else to change for "full width").
      var qtyWrap = root.querySelector('[data-qty]');
      var qtyInput = qtyWrap ? qtyWrap.querySelector('[data-qval]') : null;
      // Queried from `document`, not `root`: the sticky bar renders as a
      // sibling of .hd-duo (right after </product-info> in the Liquid),
      // not a descendant of it, since it needs to sit outside the
      // sticky-info column's own stacking/positioning context. Same
      // reasoning applies to the mobile bottom bar's price.
      var stickyPriceEl = document.querySelector('[data-sticky-price]');
      var mbarPriceEl = document.querySelector('[data-mbar-price]');
      var opts = optionsWrap.querySelectorAll('[data-opt]');
      // Main-image swap (2026-10-30): desktop's gallery featured slide
      // (marked data-hd-main-desktop in custom-product-media-gallery.liquid)
      // and the mobile rail's single <img> (data-hd-main, already existed
      // for the rail's own thumbnail-click swap) - reuses the exact same
      // fade-out/preload/fade-in technique as that existing thumbnail
      // click handler at the bottom of this file, so the two swap
      // mechanisms feel identical to a shopper even though they're
      // triggered by different UI.
      //
      // Real bug fixed here (2026-10-30, user-reported "works on mobile,
      // not desktop"): the mobile rail has exactly one <img>, so swapping
      // its src always changes what's visible. Desktop's gallery is
      // Dawn's stock multi-slide carousel - every slide's <img> exists in
      // the DOM simultaneously, and only whichever one carries .is-active
      // is actually shown/scrolled into view. The original fix only ever
      // swapped the *featured* slide's <img> (data-hd-main-desktop), so
      // if a shopper had already clicked a different gallery thumbnail
      // (image 2 or 3) before choosing a purchase option, the swap
      // silently updated an off-screen slide while the visible one never
      // changed - confirmed live by clicking thumbnail 2 then checking
      // which <li> actually carried .is-active vs which one the swap was
      // targeting (two different elements). Fixed by calling the
      // media-gallery custom element's own public setActiveMedia() first
      // (assets/media-gallery.js - also used by its native thumbnail
      // click handler), which resets the carousel back to the featured
      // slide and correctly re-syncs the thumbnail highlight state, then
      // swapping that now-active slide's image as before.
      var desktopMainLi = root.querySelector('[data-hd-main-desktop]');
      var desktopMainImg = desktopMainLi ? desktopMainLi.querySelector('img') : null;
      var mediaGalleryEl = desktopMainLi ? desktopMainLi.closest('media-gallery') : null;
      var mobileMainImg = root.querySelector('[data-hd-main]');
      // Sticky bar's own thumbnail (queried from `document`, not `root` -
      // same reasoning as stickyPills/stickyPriceEl, it's a sibling of
      // .hd-duo, not a descendant) - was missing from the swap list below,
      // so switching plans updated the gallery but left the sticky bar
      // showing whichever product's image loaded on page load.
      var stickyMainImg = document.querySelector('.hd-duo-sticky__img');
      var mbarMainImg = document.querySelector('.hd-duo-mbar__img');

      // Resets which slide is "active" without calling media-gallery's own
      // setActiveMedia() - that method also scrolls the gallery into view,
      // which jumped the whole page back up when a sticky-bar pill was
      // clicked far down the page. We only need the state reset here.
      function resetGalleryActiveSlide() {
        if (!desktopMainLi || !mediaGalleryEl) return;
        var viewer = mediaGalleryEl.querySelector('[id^="GalleryViewer"]');
        if (viewer) {
          viewer.querySelectorAll('[data-media-id]').forEach(function (el) {
            el.classList.toggle('is-active', el === desktopMainLi);
          });
        }
        var thumbnails = mediaGalleryEl.querySelector('[id^="GalleryThumbnails"]');
        if (thumbnails) {
          thumbnails.querySelectorAll('button').forEach(function (btn) {
            btn.removeAttribute('aria-current');
          });
          var activeThumb = thumbnails.querySelector('[data-target="' + desktopMainLi.dataset.mediaId + '"] button');
          if (activeThumb) activeThumb.setAttribute('aria-current', true);
        }
      }

      // img.srcset (Dawn renders one at every breakpoint width) wins over
      // img.src per spec, so setting src alone never changed what rendered -
      // must clear srcset too or the browser keeps using its old candidate.
      function swapMainImage(url) {
        resetGalleryActiveSlide();
        [desktopMainImg, mobileMainImg, stickyMainImg, mbarMainImg].forEach(function (img) {
          if (!img || !url || img.src === url) return;
          var preloader = new Image();
          preloader.onload = function () {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = url;
            img.style.opacity = 1;
          };
          img.style.opacity = 0;
          preloader.src = url;
        });
      }

      function activeCadencePill(optEl) {
        return optEl.querySelector('[data-cadence].is-active') || optEl.querySelector('[data-cadence]');
      }

      // Sticky bar pill toggle (2026-10-31): queried from `document`, not
      // `root`, same reasoning as stickyPriceEl/mbarPriceEl above - the
      // sticky bar is a sibling of .hd-duo, not a descendant. Synced by
      // position (pill N <-> opts[N]), not by label text, since both are
      // rendered from the exact same conditional set in Liquid.
      var stickyPills = document.querySelectorAll('[data-sticky-pill]');
      var stickyAtcLabel = document.querySelector('[data-sticky-atc-label]');

      // Mobile mbar plan/Change + bottom sheet (2026-10-31) - mirrors the
      // sticky pills above but as a "Change" link opening a plan picker,
      // matching docs/.../07 PDP - Supplement v2.html's .mb-line/.psheet.
      var mbarPlanEl = document.querySelector('[data-mbar-plan]');
      var mbarAtcLabel = document.querySelector('[data-mbar-atc-label]');
      var mbarChangeBtn = document.querySelector('[data-mbar-change]');
      var planSheet = document.querySelector('[data-hd-plan-sheet]');
      var planSheetOptsWrap = planSheet ? planSheet.querySelector('[data-hd-plan-sheet-opts]') : null;
      var planSheetOpts = [];
      var planSheetLastFocus = null;

      function openPlanSheet() {
        if (!planSheet) return;
        planSheetLastFocus = document.activeElement;
        planSheet.hidden = false;
        document.body.style.overflow = 'hidden';
        var pressed = planSheetOptsWrap.querySelector('[aria-pressed="true"]');
        (pressed || planSheetOptsWrap.querySelector('.hd-psopt')).focus();
      }

      function closePlanSheet() {
        if (!planSheet) return;
        planSheet.hidden = true;
        document.body.style.overflow = '';
        if (planSheetLastFocus) planSheetLastFocus.focus();
      }

      // Wires the plan sheet's own server-rendered .hd-psopt rows (2026-11-02
      // - previously built from scratch here via optEl.textContent, which
      // could only ever copy plain text, never the strike-through price
      // markup or independent drawer-only copy now rendered by Liquid, see
      // the hd-plan-sheet markup's own comment for the full reasoning).
      // Still synced to `opts` by plain array position, same as before and
      // same as the sticky pills - the Liquid conditionals rendering each
      // .hd-psopt row use the exact same show_subscription/show_30day order
      // as the main options list, so position i always means the same plan
      // in both places.
      function buildPlanSheet() {
        if (!planSheetOptsWrap) return;
        planSheetOpts = Array.prototype.slice.call(planSheetOptsWrap.querySelectorAll('[data-hd-psopt]'));
        planSheetOpts.forEach(function (btn, i) {
          var optEl = opts[i];
          if (!optEl) return;
          btn.addEventListener('click', function () {
            var radio = optEl.querySelector('[data-opt-radio]');
            if (radio) radio.checked = true;
            applySelection(optEl);
            setTimeout(closePlanSheet, 180);
          });
        });
      }

      if (mbarChangeBtn) mbarChangeBtn.addEventListener('click', openPlanSheet);
      if (planSheet) {
        planSheet.querySelectorAll('[data-hd-plan-sheet-close]').forEach(function (btn) {
          btn.addEventListener('click', closePlanSheet);
        });
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && !planSheet.hidden) closePlanSheet();
        });
      }

      function applySelection(optEl) {
        opts.forEach(function (el) {
          el.classList.toggle('is-sel', el === optEl);
        });

        var optIndex = Array.prototype.indexOf.call(opts, optEl);
        stickyPills.forEach(function (p, i) {
          p.setAttribute('aria-checked', i === optIndex ? 'true' : 'false');
        });
        planSheetOpts.forEach(function (p, i) {
          p.setAttribute('aria-pressed', i === optIndex ? 'true' : 'false');
        });
        if (mbarPlanEl && stickyPills[optIndex]) mbarPlanEl.textContent = stickyPills[optIndex].textContent;

        var variantId = optEl.getAttribute('data-variant-id');
        if (variantIdInput && variantId) variantIdInput.value = variantId;

        var mainImage = optEl.getAttribute('data-main-image');
        if (mainImage) swapMainImage(mainImage);

        var sellingPlanId = optEl.getAttribute('data-selling-plan');

        if (sellingPlanId === '') {
          // data-opt-price-value, not data-opt-price itself (bug fixed
          // 2026-11-02): once a strike-through price shares the same
          // [data-opt-price] element as the real price (PR #333), reading
          // the container's whole textContent concatenated both together
          // ("$254.85 $199.95") into every price mirror below, including
          // the sticky bar - which then visually showed just the
          // strike-through figure, since it renders first and the sticky
          // bar's own width/overflow cut off the rest. data-opt-price-value
          // wraps only the real, active price.
          var oneTimePriceEl = optEl.querySelector('[data-opt-price-value]') || optEl.querySelector('[data-opt-price]');
          var oneTimePrice = oneTimePriceEl.textContent.trim();
          if (qtyWrap) qtyWrap.hidden = false;
          if (sellingPlanInput) sellingPlanInput.value = '';
          if (atcPriceEl) atcPriceEl.textContent = oneTimePrice;
          if (priceValueEl) priceValueEl.textContent = oneTimePrice;
          if (stickyPriceEl) stickyPriceEl.textContent = oneTimePrice;
          if (mbarPriceEl) mbarPriceEl.textContent = oneTimePrice;
          if (priceNoteEl) priceNoteEl.hidden = false;
          if (stickyAtcLabel) stickyAtcLabel.textContent = stickyAtcLabel.dataset.addToCartText || stickyAtcLabel.textContent;
          if (mbarAtcLabel) mbarAtcLabel.textContent = mbarAtcLabel.dataset.addToCartText || mbarAtcLabel.textContent;
          return;
        }

        // Falls back to the label's own data-selling-plan-price when there's
        // no cadence pill to read from (2026-11-01) - the single-cadence
        // pill row is no longer rendered at all when there's nothing to
        // actually choose between (see cadence_count above), so this can no
        // longer assume a pill always exists.
        var pill = activeCadencePill(optEl);
        var sellingPlanPrice = pill ? pill.getAttribute('data-price') : optEl.getAttribute('data-selling-plan-price');
        if (pill) sellingPlanId = pill.getAttribute('data-selling-plan-id');
        if (!sellingPlanPrice) return;

        if (qtyWrap) {
          qtyWrap.hidden = true;
          if (qtyInput) qtyInput.value = 1;
        }
        if (sellingPlanInput) sellingPlanInput.value = sellingPlanId;
        if (atcPriceEl) atcPriceEl.textContent = sellingPlanPrice;
        if (priceValueEl) priceValueEl.textContent = sellingPlanPrice;
        if (stickyPriceEl) stickyPriceEl.textContent = sellingPlanPrice;
        if (mbarPriceEl) mbarPriceEl.textContent = sellingPlanPrice;
        if (priceNoteEl) priceNoteEl.hidden = true;
        // Matches the prototype's .sb-btn text swapping to "Subscribe"
        // when a selling plan is active (docs/phase 1 and phase 2
        // remaining pages/shopify-site/07 PDP - Supplement v2.html's
        // sync() function) - stored on first read so it works
        // regardless of the block settings' translated button label.
        if (stickyAtcLabel) {
          if (!stickyAtcLabel.dataset.addToCartText) stickyAtcLabel.dataset.addToCartText = stickyAtcLabel.textContent.trim();
          stickyAtcLabel.textContent = 'Subscribe';
        }
        if (mbarAtcLabel) {
          if (!mbarAtcLabel.dataset.addToCartText) mbarAtcLabel.dataset.addToCartText = mbarAtcLabel.textContent.trim();
          mbarAtcLabel.textContent = 'Subscribe';
        }
      }

      opts.forEach(function (optEl) {
        var radio = optEl.querySelector('[data-opt-radio]');
        if (radio) {
          radio.addEventListener('change', function () {
            applySelection(optEl);
          });
        }

        optEl.addEventListener('click', function (event) {
          if (event.target.closest('[data-cadence]')) return;
          if (radio) radio.checked = true;
          applySelection(optEl);
        });
      });

      stickyPills.forEach(function (stickyPill, i) {
        stickyPill.addEventListener('click', function () {
          var optEl = opts[i];
          if (!optEl) return;
          var radio = optEl.querySelector('[data-opt-radio]');
          if (radio) radio.checked = true;
          applySelection(optEl);
        });
      });

      buildPlanSheet();

      optionsWrap.querySelectorAll('[data-cadence]').forEach(function (pill) {
        pill.addEventListener('click', function (event) {
          event.preventDefault();

          var optEl = pill.closest('[data-opt]');

          optEl.querySelectorAll('[data-cadence]').forEach(function (candidate) {
            candidate.classList.toggle('is-active', candidate === pill);
          });

          var priceEl = optEl.querySelector('[data-opt-price]');
          if (priceEl) {
            var strike = priceEl.querySelector('.hd-duo__strike');
            // Rebuilds with the same data-opt-price-value wrapper the
            // Liquid markup renders (not just the bare price text) - this
            // rewrite used to strip it, so clicking a cadence pill would
            // silently reintroduce the same concatenated-text bug fixed
            // above for the very next applySelection() call.
            priceEl.innerHTML = (strike ? strike.outerHTML + ' ' : '') + '<span data-opt-price-value>' + pill.getAttribute('data-price') + '</span>';
          }

          // Mirrors the same price into the plan sheet's matching row
          // (synced by position, same as everywhere else) - without this,
          // switching billing frequency in the main card wouldn't be
          // reflected next time the drawer was opened.
          var optIndexForCadence = Array.prototype.indexOf.call(opts, optEl);
          var planSheetPriceEl = planSheetOpts[optIndexForCadence] ? planSheetOpts[optIndexForCadence].querySelector('[data-hd-psopt-price]') : null;
          if (planSheetPriceEl) planSheetPriceEl.textContent = pill.getAttribute('data-price');

          var saveEl = optEl.querySelector('[data-save-badge]');
          if (saveEl) saveEl.textContent = pill.getAttribute('data-save-label');

          var radio = optEl.querySelector('[data-opt-radio]');
          if (radio) radio.checked = true;

          applySelection(optEl);
        });
      });

      // Sync price/variant-id/selling-plan state to whichever option is
      // checked server-side on load (2026-10-29, fixed as part of the
      // 3-plan toggle: previously the server-rendered default was always
      // the one-time option, same price as the ATC button's own
      // server-rendered default, so this gap was never visible - once
      // Subscribe became the default-checked option, the ATC button kept
      // showing the one-time price until the user manually changed the
      // radio, since nothing had ever called applySelection on load).
      var checkedOpt = optionsWrap.querySelector('[data-opt-radio]:checked');
      if (checkedOpt) applySelection(checkedOpt.closest('[data-opt]'));
    }

    function initQuantityStepper(root) {
      root.querySelectorAll('[data-qty]').forEach(function (qty) {
        var input = qty.querySelector('[data-qval]');
        var dec = qty.querySelector('[data-dec]');
        var inc = qty.querySelector('[data-inc]');
        if (!input || !dec || !inc) return;

        dec.addEventListener('click', function () {
          var value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          input.value = value;
        });

        inc.addEventListener('click', function () {
          var value = (parseInt(input.value, 10) || 1) + 1;
          input.value = value;
        });
      });
    }

    function initStickyBar() {
      // Match whichever purchase option is selected by default server-side
      // (the main price display already reflects it correctly at render
      // time - see snippets/custom-price-duo.liquid) rather than
      // re-deriving that default-selection logic a second time in JS.
      // Covers both the desktop top bar and the mobile bottom bar
      // (.hd-duo-mbar) - independent of each other, so this runs
      // regardless of which one(s) exist in the DOM.
      var mainPriceEl = document.querySelector('[data-price-value]');
      var mbarPriceEl = document.querySelector('[data-mbar-price]');
      if (mbarPriceEl && mainPriceEl) {
        mbarPriceEl.textContent = mainPriceEl.textContent;
      }

      var bar = document.querySelector('[data-hd-sticky-bar]');
      var sentinel = document.querySelector('[data-hd-sticky-sentinel]');
      var mbar = document.querySelector('[data-hd-mbar]');
      if (!bar || !sentinel) return;

      var stickyPriceEl = bar.querySelector('[data-sticky-price]');
      if (stickyPriceEl && mainPriceEl) {
        stickyPriceEl.textContent = mainPriceEl.textContent;
      }

      // DEVIATION FROM docs/assets/pdp.js: the prototype drives this via a
      // single IntersectionObserver({threshold:0}) toggling 'show' off
      // entry.isIntersecting/entry.boundingClientRect.top. Live-tested on
      // this actual page (gradual, real-scroll-position tests, not just an
      // instant jump) and confirmed that mechanism can silently miss the
      // sentinel's crossing - a page-load-created observer sometimes never
      // fires again after its initial callback even while the sentinel
      // visibly passes through the viewport across many rendered frames.
      // Root cause not conclusively pinned down (ruled out: exceptions, a
      // stale/duplicate bar or sentinel element, a monkey-patched
      // IntersectionObserver, a stale compiled bundle), only confirmed to
      // recur even with a freshly-created observer with identical logic -
      // so the fix here doesn't depend on IO firing reliably at all: a
      // passive, rAF-throttled scroll listener recomputes the sentinel's
      // real boundingClientRect on every scroll frame directly, which
      // cannot miss a transition the way IO's batched reporting apparently
      // can. Kept simple (no IO at all) rather than layering a scroll
      // listener on top of IO as a "fallback" - one deterministic mechanism
      // beats debugging two that disagree.
      var ticking = false;
      function updateStickyBar() {
        ticking = false;
        var top = sentinel.getBoundingClientRect().top;
        var shouldShow = top < 0;
        bar.classList.toggle('show', shouldShow);
        // Mobile bottom bar (.hd-duo-mbar) shares this exact same
        // trigger, per explicit user request (2026-08-03) that it
        // reveal on scroll like the desktop bar rather than being
        // permanently visible - see the CSS comment above.
        if (mbar) mbar.classList.toggle('show', shouldShow);
      }
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(updateStickyBar);
        },
        { passive: true }
      );
      updateStickyBar();
    }

    document.querySelectorAll('.hd-duo').forEach(function (section) {
      initAccordion(section);
      initPurchaseOptions(section);
      initQuantityStepper(section);
    });

    initStickyBar();

    // Marks <body> (not .hd-duo) because product-modal.js moves
    // <product-modal> to be a direct child of <body> on connect - the
    // lightbox-image-fit CSS above targets this class instead of a
    // .hd-duo ancestor selector, which would never match post-move.
    if (document.querySelector('.hd-duo')) {
      document.body.classList.add('hd-duo-modal-fit');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-product-single"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAccordion(root) {
      root.querySelectorAll('[data-hd-acc-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var row = trigger.closest('.hd-acc__row');
          var panel = row.querySelector('[data-hd-acc-panel]');
          var isOpen = row.classList.contains('is-open');

          if (isOpen) {
            panel.style.height = panel.scrollHeight + 'px';
            requestAnimationFrame(function () {
              panel.style.height = '0px';
            });
            row.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            row.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            panel.style.height = panel.scrollHeight + 'px';
            panel.addEventListener('transitionend', function handler() {
              panel.style.height = 'auto';
              panel.removeEventListener('transitionend', handler);
            });
          }
        });
      });
    }

    function initQuantityStepper(root) {
      root.querySelectorAll('[data-qty]').forEach(function (qty) {
        var input = qty.querySelector('[data-qval]');
        var dec = qty.querySelector('[data-dec]');
        var inc = qty.querySelector('[data-inc]');
        if (!input || !dec || !inc) return;

        dec.addEventListener('click', function () {
          var value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
          input.value = value;
        });

        inc.addEventListener('click', function () {
          var value = (parseInt(input.value, 10) || 1) + 1;
          input.value = value;
        });
      });
    }

    function initStickyBar() {
      // Match whichever purchase option is selected by default server-side
      // (the main price display already reflects it correctly at render
      // time - see snippets/custom-price-duo.liquid) rather than
      // re-deriving that default-selection logic a second time in JS.
      // Covers both the desktop top bar and the mobile bottom bar
      // (.hd-duo-mbar) - independent of each other, so this runs
      // regardless of which one(s) exist in the DOM.
      var mainPriceEl = document.querySelector('[data-price-value]');
      var mbarPriceEl = document.querySelector('[data-mbar-price]');
      if (mbarPriceEl && mainPriceEl) {
        mbarPriceEl.textContent = mainPriceEl.textContent;
      }

      var bar = document.querySelector('[data-hd-sticky-bar]');
      var sentinel = document.querySelector('[data-hd-sticky-sentinel]');
      var mbar = document.querySelector('[data-hd-mbar]');
      if (!bar || !sentinel) return;

      var stickyPriceEl = bar.querySelector('[data-sticky-price]');
      if (stickyPriceEl && mainPriceEl) {
        stickyPriceEl.textContent = mainPriceEl.textContent;
      }

      // DEVIATION FROM docs/assets/pdp.js: the prototype drives this via a
      // single IntersectionObserver({threshold:0}) toggling 'show' off
      // entry.isIntersecting/entry.boundingClientRect.top. Live-tested on
      // this actual page (gradual, real-scroll-position tests, not just an
      // instant jump) and confirmed that mechanism can silently miss the
      // sentinel's crossing - a page-load-created observer sometimes never
      // fires again after its initial callback even while the sentinel
      // visibly passes through the viewport across many rendered frames.
      // Root cause not conclusively pinned down (ruled out: exceptions, a
      // stale/duplicate bar or sentinel element, a monkey-patched
      // IntersectionObserver, a stale compiled bundle), only confirmed to
      // recur even with a freshly-created observer with identical logic -
      // so the fix here doesn't depend on IO firing reliably at all: a
      // passive, rAF-throttled scroll listener recomputes the sentinel's
      // real boundingClientRect on every scroll frame directly, which
      // cannot miss a transition the way IO's batched reporting apparently
      // can. Kept simple (no IO at all) rather than layering a scroll
      // listener on top of IO as a "fallback" - one deterministic mechanism
      // beats debugging two that disagree.
      var ticking = false;
      function updateStickyBar() {
        ticking = false;
        var top = sentinel.getBoundingClientRect().top;
        var shouldShow = top < 0;
        bar.classList.toggle('show', shouldShow);
        // Mobile bottom bar (.hd-duo-mbar) shares this exact same
        // trigger, per explicit user request (2026-08-03) that it
        // reveal on scroll like the desktop bar rather than being
        // permanently visible - see the CSS comment above.
        if (mbar) mbar.classList.toggle('show', shouldShow);
      }
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(updateStickyBar);
        },
        { passive: true }
      );
      updateStickyBar();
    }

    document.querySelectorAll('.hd-duo').forEach(function (section) {
      initAccordion(section);
      initQuantityStepper(section);
    });

    initStickyBar();

    // Marks <body> (not .hd-duo) because product-modal.js moves
    // <product-modal> to be a direct child of <body> on connect - the
    // lightbox-image-fit CSS above targets this class instead of a
    // .hd-duo ancestor selector, which would never match post-move.
    if (document.querySelector('.hd-duo')) {
      document.body.classList.add('hd-duo-modal-fit');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hd-faq-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-hd-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-ingredient-index"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fx]').forEach(function (fx) {
      var num = fx.querySelector('[data-fx-num]');
      var prog = fx.querySelector('[data-fx-prog]');
      var lists = [].slice.call(fx.querySelectorAll('.hd-fx__list'));
      var seq = [];
      var fills = [];
      var hls = [];

      lists.forEach(function (list) {
        var fillEl = list.querySelector('[data-fx-fill]');
        fills.push(fillEl);
        var hlEl = document.createElement('span');
        hlEl.className = 'hd-fx__hl';
        list.insertBefore(hlEl, list.firstChild);
        hls.push(hlEl);
        var rows = [].slice.call(list.querySelectorAll('.hd-fx__row'));
        rows.forEach(function (row, idx) {
          seq.push({ row: row, fill: fillEl, hl: hlEl, pos: idx, len: rows.length });
        });
      });

      var N = seq.length;
      var timer = null;

      function pad(n) {
        return (n < 10 ? '0' : '') + n;
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var SPEED = parseInt(fx.getAttribute('data-fx-speed'), 10) || 196;

      function reset() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        seq.forEach(function (s) {
          s.row.classList.remove('is-active', 'is-done');
        });
        fills.forEach(function (f) {
          f.style.transition = 'none';
          f.style.height = '0%';
        });
        hls.forEach(function (h) {
          h.style.transition = 'none';
          h.style.opacity = '0';
          h.style.height = '0px';
        });
        if (num) num.textContent = '01';
        if (prog) prog.style.width = '0%';
        fx.classList.remove('is-fin');
      }

      function run() {
        if (reduce) {
          seq.forEach(function (s) {
            s.row.classList.add('is-done');
          });
          fills.forEach(function (f) {
            f.style.height = '100%';
          });
          if (num) num.textContent = pad(N);
          if (prog) prog.style.width = '100%';
          fx.classList.add('is-fin');
          return;
        }

        var i = 0;

        (function step() {
          if (i > 0) {
            seq[i - 1].row.classList.remove('is-active');
            seq[i - 1].row.classList.add('is-done');
          }
          if (i >= N) {
            hls.forEach(function (h) {
              h.style.transition = 'opacity .45s';
              h.style.opacity = '0';
            });
            timer = null;
            fx.classList.add('is-fin');
            return;
          }
          var s = seq[i];
          s.row.classList.add('is-active');
          if (s.hl) {
            var hT = s.row.offsetTop + 'px';
            var hH = s.row.offsetHeight + 'px';
            if (s.pos === 0) {
              s.hl.style.transition = 'none';
              s.hl.style.top = hT;
              s.hl.style.height = hH;
              s.hl.style.opacity = '1';
              void s.hl.offsetHeight;
            } else {
              s.hl.style.transition = 'top ' + SPEED + 'ms linear, height ' + SPEED + 'ms linear';
              s.hl.style.top = hT;
              s.hl.style.height = hH;
            }
          }
          if (num) num.textContent = pad(i + 1);
          if (s.pos === 0) {
            void s.fill.offsetHeight;
            s.fill.style.transition = 'height ' + (s.len * SPEED) + 'ms linear';
            s.fill.style.height = '100%';
          }
          if (prog) prog.style.width = ((i + 1) / N * 100) + '%';
          i++;
          timer = setTimeout(step, SPEED);
        })();
      }

      if (!('IntersectionObserver' in window)) {
        run();
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reset();
            run();
          } else {
            reset();
          }
        });
      }, { threshold: 0.2 });

      io.observe(fx);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-reviews-heading"] && !Shopify.designMode) return;
  try {
    
  /* Okendo's star-rating click scroll (default target and its own
     "Scroll to custom target" setting alike) ignores scroll-margin-top
     entirely - confirmed live at 8rem and 16rem, identical landing
     position both times. Traced the actual mechanism by wrapping
     window.scrollTo: Okendo animates via dozens of direct
     window.scrollTo(0, Y) calls (a hand-rolled eased loop, not native
     scrollIntoView) converging on its own fixed target, then
     sometimes re-triggers a second such animation later (timing
     varies, likely tied to the widget's lazy-loaded photos finishing).
     A correct-after-the-fact approach (an earlier version of this
     file) worked but was visibly two scrolls: Okendo's own animation
     landing the heading covered, a pause, then a second corrective
     scroll revealing it - confirmed by a user report describing
     exactly that sequence.

     Fixed properly by intercepting every window.scrollTo call during
     the click and capping its Y at the position we actually need.
     This is always safe in one direction only: our required clearance
     means we need LESS scroll than Okendo's own target (we want the
     heading further down/earlier in Okendo's approach, never further
     up past it), confirmed live (neededY 4119.7 vs Okendo's own target
     4296.8 in one traced run) - so Math.min(okendoY, neededY) always
     lands Okendo's own animation curve short of its real target and
     right at ours, in one continuous motion, for however many times
     it calls scrollTo during the patched window. Listener must be
     capture-phase (true, 3rd arg) - Okendo's own click handler calls
     stopPropagation(), confirmed live a bubble-phase listener never
     fires at all. */
  (function () {
    var target = document.getElementById('pdp-reviews');
    if (!target) return;

    function clearance() {
      return window.matchMedia('(min-width: 821px)').matches ? 160 : 80;
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-oke-star-rating]')) return;

      var neededY = target.getBoundingClientRect().top + window.scrollY - clearance();
      var origScrollTo = window.scrollTo;
      var restored = false;

      function restore() {
        if (restored) return;
        restored = true;
        window.scrollTo = origScrollTo;
      }

      window.scrollTo = function (x, y) {
        if (x !== null && typeof x === 'object') {
          if (typeof x.top === 'number' && x.top > neededY) {
            var capped = {};
            for (var key in x) capped[key] = x[key];
            capped.top = neededY;
            return origScrollTo.call(window, capped);
          }
          return origScrollTo.call(window, x);
        }
        if (typeof y === 'number' && y > neededY) {
          return origScrollTo.call(window, x, neededY);
        }
        return origScrollTo.apply(window, arguments);
      };

      setTimeout(restore, 10000);

      /* Safety net: if Okendo's scroll never reaches neededY at all
         (falls short for its own reasons), nudge once after the
         patched window closes rather than leaving it stuck covered. */
      setTimeout(function () {
        var top = target.getBoundingClientRect().top;
        var needed = clearance();
        if (top < needed) {
          window.scrollBy({ top: top - needed, behavior: 'smooth' });
        }
      }, 10200);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-rewards-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hd-rewards-faq-item]').forEach(function (item) {
      var toggle = item.querySelector('[data-hd-rewards-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-search-overlay"]) return;
  try {
    
  class HdSearchOverlay extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.hd-search-overlay__input');
      this.emptyState = this.querySelector('[data-hd-search-empty]');

      this.querySelectorAll('[data-hd-search-cancel]').forEach((btn) => {
        btn.addEventListener('click', this.close.bind(this));
      });
      this.input.addEventListener('input', this.onInput.bind(this));
      // The X button is a real <button type="reset"> inside
      // .hd-search-overlay__form (Dawn's own predictive-search reset
      // control) - clicking it clears the input via the browser's native
      // form-reset behavior, which fires a "reset" event on the <form>,
      // not an "input" event on the text field. onInput() above only
      // listens for "input", so clicking the X never re-showed the
      // empty-state "Popular searches"/"Popular products" (confirmed
      // user-reported: backspacing the text out worked correctly, since
      // real typing/deleting always fires genuine "input" events, but
      // the X button never did).
      //
      // Per the HTML spec, the "reset" event fires *before* the browser
      // actually clears the form's fields, not after - confirmed live
      // (this.input.value was still the typed search term inside a
      // "reset" handler). Calling onInput() synchronously here would
      // read the stale, not-yet-cleared value and leave the empty state
      // wrongly hidden. Deferring one frame via requestAnimationFrame
      // runs onInput() after the browser's own reset algorithm has
      // finished clearing the field.
      var hdSearchForm = this.querySelector('.hd-search-overlay__form');
      if (hdSearchForm) {
        hdSearchForm.addEventListener('reset', () => {
          window.requestAnimationFrame(this.onInput.bind(this));
        });
      }
      // Dawn's predictive-search.js closes/clears its own results
      // whenever focus leaves the <predictive-search> element at all
      // (onFocusOut in assets/predictive-search.js) - built for a small
      // inline header dropdown, where "focus left it" unambiguously
      // means "done searching". Inside this full-page overlay,
      // <predictive-search> wraps the entire panel (bar + Popular
      // section + results), so this fired on any click on a
      // non-focusable area of the overlay too (clicking blank space
      // resets document.activeElement to <body>, which is outside
      // <predictive-search>), wiping the results even though the user
      // was still inside the search overlay - confirmed user-reported
      // ("results vanished when clicking outside somewhere"). The
      // overlay already has its own explicit close controls (Cancel
      // button, Escape below), so intercept "focusout" at the capture
      // phase - which reaches this element strictly before Dawn's own
      // bubble-phase listener registered on the same element - and stop
      // it there so results persist until the overlay itself is closed.
      // Scoped to only this instance (not a customElements prototype
      // patch), so main-search.liquid's separate <predictive-search> on
      // the real /search results page keeps Dawn's original
      // close-on-blur behavior untouched.
      var hdPredictiveSearch = this.querySelector('predictive-search');
      if (hdPredictiveSearch) {
        hdPredictiveSearch.addEventListener(
          'focusout',
          (event) => {
            event.stopImmediatePropagation();
          },
          true
        );
      }
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) this.close();
      });
      document.querySelectorAll('[data-hd-search-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        });
      });
    }

    open() {
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden', 'hd-search-open');
      window.setTimeout(() => this.input.focus(), 50);
    }

    close() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden', 'hd-search-open');
      this.input.value = '';
      this.onInput();
    }

    onInput() {
      this.emptyState.hidden = this.input.value.trim().length > 0;
    }
  }

  customElements.define('hd-search-overlay', HdSearchOverlay);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.customSlideshowParallaxInit) return;
  window.customSlideshowParallaxInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  var layers = [];

  function collect() {
    layers = Array.prototype.slice.call(document.querySelectorAll('.custom-slideshow__media--parallax'));
  }

  function update() {
    var viewportH = window.innerHeight;
    layers.forEach(function (layer) {
      var rect = layer.getBoundingClientRect();
      var progress = (rect.top) / viewportH;
      var offset = progress * 24;
      var direction = layer.getAttribute('data-parallax-direction');
      var media = layer.querySelector('.custom-slideshow__image, .custom-slideshow__video');
      if (!media) return;
      if (direction === 'left') {
        media.style.transform = 'translateX(' + offset + 'px)';
      } else {
        media.style.transform = 'translateY(' + offset + 'px)';
      }
    });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    collect();
    update();
  });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', collect);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var spots = document.querySelectorAll('.hd-spot');
    if (!spots.length) return;

    if (!('IntersectionObserver' in window)) {
      spots.forEach(function (spot) {
        spot.classList.add('in-view');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('in-view', entry.isIntersecting);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    spots.forEach(function (spot) {
      io.observe(spot);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initUgcRail(rail) {
      var track = rail.closest('[data-hd-ugc-track]');
      if (!track) return;

      if (reduceMotion) {
        track.style.overflowX = 'auto';
        return;
      }

      var distance = rail.scrollWidth / 2;
      if (!distance) return;

      var duration = parseFloat(rail.getAttribute('data-scroll-duration')) || 55;
      var speed = distance / duration;
      var offset = 0;
      var paused = false;
      var lastTime = null;

      track.addEventListener('mouseenter', function () {
        paused = true;
      });

      track.addEventListener('mouseleave', function () {
        paused = false;
      });

      function tick(time) {
        if (lastTime === null) lastTime = time;
        var delta = (time - lastTime) / 1000;
        lastTime = time;

        if (!paused) {
          offset -= speed * delta;
          if (offset <= -distance) offset += distance;
          rail.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
        }

        requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }

    document.querySelectorAll('[data-hd-ugc-rail]').forEach(initUgcRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
